import { enumStatuses } from '../../consts/status';

export const MobileFilterSheet = ({
    open,
    onClose,
    options,
    selectedOptions,
    onChange,
    testId
}) => {
    if (!open) return null;
    const activeCount = selectedOptions.length;

    const toggleOption = (option) => {
        onChange(
            selectedOptions.includes(option)
                ? selectedOptions.filter((selected) => selected !== option)
                : [...selectedOptions, option]
        );
    };

    return (
        <div className="md:hidden fixed inset-0 z-50" data-testid={testId}>
            <div className="absolute inset-0 bg-black/40" onClick={onClose} />
            <div className="absolute bottom-0 inset-x-0 bg-white rounded-t-2xl shadow-2xl pb-[env(safe-area-inset-bottom)]">
                <div className="mx-auto mt-2 h-1.5 w-10 rounded-full bg-gray-300" />
                <div className="px-4 pt-3 pb-2">
                    <h3 className="text-base font-semibold">Filters</h3>
                </div>
                <div className="px-4 pb-2 space-y-5">
                    <div>
                        <div className="text-xs font-semibold tracking-widest text-gray-500 mb-2">STATUS</div>
                        <div className="space-y-1">
                            {options?.map((option) => (
                                <label
                                    key={option}
                                    className="flex items-center gap-3 py-2 px-1 rounded-md active:bg-gray-100 transition-colors"
                                >
                                    <input
                                        type="checkbox"
                                        checked={selectedOptions.includes(option)}
                                        onChange={() => toggleOption(option)}
                                        className="h-5 w-5 rounded border-gray-300 text-primary focus:ring-primary"
                                    />
                                    <span className="text-sm">{enumStatuses[option]}</span>
                                </label>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="flex gap-2 px-4 pt-3 pb-4">
                    {activeCount > 0 && (
                        <button
                            onClick={() => onChange([])}
                            className="flex-1 h-11 rounded-md border border-gray-300 bg-white text-sm font-medium hover:bg-gray-50 transition-colors"
                        >
                            Clear all
                        </button>
                    )}
                    <button
                        onClick={onClose}
                        className="flex-1 h-11 rounded-md bg-gray-900 text-white text-sm font-semibold hover:bg-gray-800 transition-colors"
                    >
                        Done{activeCount > 0 ? ` (${activeCount})` : ''}
                    </button>
                </div>
            </div>
        </div>
    );
};
